import React from "react";
import { Container, Button } from "react-bootstrap";
import logoIcon from "../assets/images/logo-icon.svg";
import { Link } from "react-router-dom";
import Seo from "../seo/Seo";

const ThankYou = () => {
  return (
    <Container style={{ marginTop: "120px" }}>
      <Seo
        title="Thank you | Connct"
        description="Your Connct order is complete."
        path="/thank-you"
        noindex
      />
      <section className="section">
        <div className="row" style={{ margin: "60px 0" }}>
          <div className="col-md-12 text-center thanks">
            <img src={logoIcon} alt="thankyou" className="thank-logo"></img>
            <h1 className="title mt-5" style={{ fontWeight: 700 }}>
              Thank you for your order.
            </h1>
            <p style={{ padding: "15px 0", fontSize: "16px" }}>
              Your order is complete. Please check your email for the details.
            </p>
            <Link to="/product-list" state={{ toPopular: true }}>
              <Button variant="outline-primary" size="lg">
                continue shopping
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Container>
  );
};

export default ThankYou;
